import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/auth/services/authentication.service';
import { TopUps } from '../models/topup';
import { TopupsService } from '../services/topups.service';

@Component({
  selector: 'app-topups',
  templateUrl: './topups.component.html',
  styleUrls: ['./topups.component.scss'],
})
export class TopupsComponent implements OnInit {

  topups:TopUps[]=[];
  details:any;
  searchKey: string;
  p: number = 1;
  constructor(private mainService:TopupsService,private authService:AuthenticationService) { }

  ngOnInit() {

    let details = this.authService.getUserDetails();
    this.mainService.getAll().subscribe(data=>{
      this.topups = data['results'];
    });
  }


}
